import axios from 'axios'
import { useMutation, useQueryClient } from 'react-query'

export const useSaveAuctionEventSettings = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (body: any) => {
      return axios.put(`/auctioneventsettings`, body)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['eventsettings'])
        queryClient.invalidateQueries(['events'])
        queryClient.invalidateQueries(['eventdata'])
      }
    }
  )
}
